var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "m2 6 4 4 8-8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkLine.1a7b47b80599191d8ca7a9c8bf94fb27.svg";